@if (shared.isLoggedIn(true)) {
  @if (!shared.isMobileConst) {
    <div class="sidebar-wrap" [class.sidebar-wrap--collapsed]="shared.sidebarCollapsed">
      <nav class="sidebar d-flex flex-column h-100 bg-dark p-2 gap-3 min-vh-100 border-end border-secondary">
        <!-- Logo area -->
        <div class="bg-yellow rounded p-2 logo-area">
          <img alt="Logo" class="main-logo cursor mt-2 my-3 mx-auto" src="assets/logo.png" routerLink="/dashboard">
          @if (locationName && !shared.sidebarCollapsed) {
            <div class="font-11 fw-bolder text-center border-dark location">
            {{locationName}}</div>
          }
        </div>
        <ng-container *ngTemplateOutlet="headerContent">
        </ng-container>

        <!-- Collapse toggle at the bottom -->
        <div class="sidebar-footer mt-auto">
          <button
            class="sidebar-toggle-btn"
            (click)="shared.cycleSidebar()"
            [title]="(shared.sidebarCollapsed ? 'sidebar.expand' : 'sidebar.collapse') | translate">
            <i class="bi"
               [class.bi-layout-sidebar-reverse]="!shared.sidebarCollapsed"
               [class.bi-layout-sidebar]="shared.sidebarCollapsed"></i>
            @if (!shared.sidebarCollapsed) {
              <span class="sidebar-toggle-label">{{ 'sidebar.collapse' | translate }}</span>
            }
          </button>
        </div>
      </nav>
    </div>
  } @else {
    <div class="d-flex align-items-center bg-yellow gap-2 p-2">
      @if (locationName) {
        <div class="font-09 fw-bolder location">
          {{locationName}}
        </div>
      }
      <img alt="Logo" class="main-logo cursor mx-auto" src="assets/logo.png" routerLink="/dashboard">
      <button class="btn btn-secondary btn-canvas ms-auto" (click)="openMenu(offcanvas)">
        <i class="bi bi-list"></i>
      </button>
    </div>
    <ng-template #offcanvas let-offcanvas>
      <div class="offcanvas-menu d-flex flex-column h-100 bg-dark p-2 w-15 gap-3 border-end border-secondary">
        <ng-container *ngTemplateOutlet="headerContent"></ng-container>
      </div>
    </ng-template>
  }
}

<ng-template #headerContent>
  <div class="links" scrollFade>
    @if (roleStatuses.length && !shared.sidebarCollapsed) {
      <div class="respo-box bg-dark border rounded pointer" (click)="navigateToShiftPlanner()">
        @for (status of roleStatuses; track status.role) {
          <div class="respo-row d-flex align-items-center">
            @if (status.current) {
              <i class="bi bi-person-badge respo-icon" [style.color]="roleColorStyle(status.role)">
              </i>
              <div class="respo-info">
                <div class="respo-role">{{(rolePrefix + status.role)|translate}}</div>
                <div class="respo-name text-light" [title]="status.current.user?.fullname">
                {{status.current.user?.fullname}}
                </div>
              </div>
              @if (status.current.user?.phone) {
                <a href="tel:{{status.current.user.phone}}" class="respo-phone text-muted"
                  (click)="$event.stopPropagation()">
                  <i class="bi bi-telephone me-1" [ngbTooltip]="status.current.user.phone" placement="bottom"></i>
                </a>
              }
              @if (status.current.user?.email) {
                <a href="tel:{{status.current.user.email}}" class="respo-phone text-muted"
                  (click)="$event.stopPropagation()">
                  <i class="bi bi-envelope me-1" [ngbTooltip]="status.current.user.email" placement="bottom"></i>
                </a>
              }
              @if (status.endingGap) {
                <i class="bi bi-exclamation-triangle-fill text-warning ms-auto"
                [ngbTooltip]="gapTooltip(status)" placement="bottom"></i>
              }
            } @else {
              <i class="bi bi-person-x text-danger respo-icon"></i>
              <div class="respo-info">
                <div class="respo-role">{{(rolePrefix + status.role)|translate}}</div>
                <div class="respo-name text-danger">{{'no_service'|translate}}</div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (roleStatuses.length && shared.sidebarCollapsed) {
      <div class="d-flex flex-column gap-2 align-items-center">
        @for (status of roleStatuses; track status.role) {
          <div class="sidebar-icon-btn clickable pointer position-relative"
            (click)="navigateToShiftPlanner()"
            [title]="status.current ? respoTitle(status.current) : ((rolePrefix + status.role)|translate) + ': ' + ('no_service'|translate)">
              <i class="bi fs-5"
                [class.bi-person-badge]="status.current"
                [style.color]="status.current ? roleColorStyle(status.role) : null"
                [class.bi-person-x]="!status.current"
                [class.text-danger]="!status.current"></i>
            @if (status.endingGap) {
              <i class="bi bi-exclamation-triangle-fill text-warning"
                 style="top:-4px; right:-4px; font-size: 0.6rem"
                 [title]="gapTooltip(status)"></i>
            }
          </div>
        }
      </div>
    }
    @if (loggedUser.hasModule('ntfy_master') && shared.generalNtfyUrl) {
      <div class="ntfy-row" [title]="'general_ntfy_topic' | translate">
        <a class="ntfy-btn" [href]="shared.generalNtfyUrl" [ngbTooltip]="shared.generalNtfyUrl" container="body"
          [attr.aria-label]="('general_ntfy_topic' | translate) + ' — ' + ('ntfy_link_app' | translate)">
          <i class="bi bi-bell"></i>
        </a>
        <a class="ntfy-btn" [href]="shared.generalNtfyWebUrl" target="_blank" rel="noopener"
          [ngbTooltip]="shared.generalNtfyWebUrl" container="body"
          [attr.aria-label]="('general_ntfy_topic' | translate) + ' — ' + ('ntfy_link_web' | translate)">
          <i class="bi bi-box-arrow-up-right"></i>
        </a>
      </div>
    }
    <a href="dashboard" routerLink="dashboard" routerLinkActive="active"
      class="btn btn-sm d-flex gap-2 align-items-center"
      [title]="'home' | translate"
      (click)="offcanvasService.dismiss()">
      <i class="bi bi-house font-12"></i>
      @if (!shared.sidebarCollapsed) { <span>{{'home'|translate}}</span> }
    </a>
    <ng-container>
      <a href="ems_portals" routerLink="ems_portals" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="(('locations' | translate) + (emsPortalErrorCount > 0 ? ' (' + emsPortalErrorCount + ')' : ''))"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-geo-alt font-12 position-relative">
          @if (emsPortalErrorCount > 0 && shared.sidebarCollapsed) {
            <span class="tk-menu-badge tk-menu-badge--err">{{ emsPortalErrorCount }}</span>
          }
        </i>
        @if (!shared.sidebarCollapsed) {
          <span>{{'locations'|translate}}</span>
          @if (emsPortalErrorCount > 0) {
            <span class="badge rounded-pill tk-menu-pill tk-menu-pill--err ms-auto">{{ emsPortalErrorCount }}</span>
          }
        }
      </a>
      <a href="skids" routerLink="skids" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="(('skids' | translate) + (skidErrorCount > 0 ? ' (' + skidErrorCount + ')' : ''))"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-battery-charging font-12 position-relative">
          @if (skidErrorCount > 0 && shared.sidebarCollapsed) {
            <span class="tk-menu-badge tk-menu-badge--err">{{ skidErrorCount }}</span>
          }
        </i>
        @if (!shared.sidebarCollapsed) {
          <span>{{'skids'|translate}}</span>
          @if (skidErrorCount > 0) {
            <span class="badge rounded-pill tk-menu-pill tk-menu-pill--err ms-auto">{{ skidErrorCount }}</span>
          }
        }
      </a>
      <a href="twin_chargers" routerLink="twin_chargers" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="(('twin_charger.twin_charger' | translate) + (twinChargerErrorCount > 0 ? ' (' + twinChargerErrorCount + ')' : ''))"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-ev-station font-12 position-relative">
          @if (twinChargerErrorCount > 0 && shared.sidebarCollapsed) {
            <span class="tk-menu-badge tk-menu-badge--err">{{ twinChargerErrorCount }}</span>
          }
        </i>
        @if (!shared.sidebarCollapsed) {
          <span>{{'twin_charger.twin_charger'|translate}}</span>
          @if (twinChargerErrorCount > 0) {
            <span class="badge rounded-pill tk-menu-pill tk-menu-pill--err ms-auto">{{ twinChargerErrorCount }}</span>
          }
        }
      </a>
      <a href="fve" routerLink="fve" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="(('fve.fve' | translate) + (fveErrorCount > 0 ? ' (' + fveErrorCount + ')' : ''))"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-sun font-12 position-relative">
          @if (fveErrorCount > 0 && shared.sidebarCollapsed) {
            <span class="tk-menu-badge tk-menu-badge--err">{{ fveErrorCount }}</span>
          }
        </i>
        @if (!shared.sidebarCollapsed) {
          <span>{{'fve.fve'|translate}}</span>
          @if (fveErrorCount > 0) {
            <span class="badge rounded-pill tk-menu-pill tk-menu-pill--err ms-auto">{{ fveErrorCount }}</span>
          }
        }
      </a>
      <a href="batteries_list" routerLink="batteries_list" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="(('batteries.battery_management' | translate) + (batteryErrorCount > 0 ? ' (' + batteryErrorCount + ')' : ''))"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-battery-half font-12 position-relative">
          @if (batteryErrorCount > 0 && shared.sidebarCollapsed) {
            <span class="tk-menu-badge tk-menu-badge--err">{{ batteryErrorCount }}</span>
          }
        </i>
        @if (!shared.sidebarCollapsed) {
          <span>{{ 'batteries.battery_management' | translate }}</span>
          @if (batteryErrorCount > 0) {
            <span class="badge rounded-pill tk-menu-pill tk-menu-pill--err ms-auto">{{ batteryErrorCount }}</span>
          }
        }
      </a>
      @if (shared.canView('Invertor') || shared.isAdmin()) {
        <a href="data-loggers" routerLink="data-loggers" routerLinkActive="active"
          class="btn btn-sm d-flex gap-2 align-items-center"
          [title]="'data_loggers.title' | translate"
          (click)="offcanvasService.dismiss()">
          <i class="bi bi-hdd-network font-12"></i>
          @if (!shared.sidebarCollapsed) { <span>{{ 'data_loggers.title' | translate }}</span> }
        </a>
      }
      <a href="battery_versions" routerLink="battery_versions" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="'batteries.battery_versions.battery_versions' | translate"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-cpu font-12"></i>
        @if (!shared.sidebarCollapsed) { <span>{{'batteries.battery_versions.battery_versions'|translate}}</span> }
      </a>
      <a href="battery-records" routerLink="battery-records" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="(('battery_records.title' | translate) + (recordsAttentionCount > 0 ? ' (' + recordsAttentionCount + ')' : ''))"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-journal-medical font-12 position-relative">
          @if (recordsAttentionCount > 0 && shared.sidebarCollapsed) {
            <span class="tk-menu-badge">{{ recordsAttentionCount }}</span>
          }
        </i>
        @if (!shared.sidebarCollapsed) {
          <span>{{'battery_records.title'|translate}}</span>
          @if (recordsAttentionCount > 0) {
            <span class="badge rounded-pill tk-menu-pill ms-auto">{{ recordsAttentionCount }}</span>
          }
        }
      </a>
      <a href="clients" routerLink="clients" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="'clients' | translate"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-people font-12"></i>
        @if (!shared.sidebarCollapsed) { <span>{{'clients'|translate}}</span> }
      </a>
      <a href="requests" routerLink="requests" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="'requests.requests' | translate"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-tools font-12"></i>
        @if (!shared.sidebarCollapsed) { <span>{{'requests.requests'|translate}}</span> }
      </a>
        <a href="solar-parks" routerLink="solar-parks" routerLinkActive="active"
          class="btn btn-sm d-flex gap-2 align-items-center"
          [title]="'solar_parks.title' | translate"
          (click)="offcanvasService.dismiss()">
          <i class="bi bi-sun font-12"></i>
          @if (!shared.sidebarCollapsed) { <span>{{'solar_parks.title'|translate}}</span> }
        </a>
        <a href="tickets" routerLink="tickets" routerLinkActive="active"
          class="btn btn-sm d-flex gap-2 align-items-center"
          [title]="(('tickets.tickets' | translate) + (ticketAttentionCount > 0 ? ' (' + ticketAttentionCount + ')' : ''))"
          (click)="offcanvasService.dismiss()">
          <i class="bi bi-kanban font-12 position-relative">
            @if (ticketAttentionCount > 0 && shared.sidebarCollapsed) {
              <span class="tk-menu-badge">{{ ticketAttentionCount }}</span>
            }
          </i>
          @if (!shared.sidebarCollapsed) {
            <span>{{'tickets.tickets'|translate}}</span>
            @if (ticketAttentionCount > 0) {
              <span class="badge rounded-pill tk-menu-pill ms-auto">{{ ticketAttentionCount }}</span>
            }
          }
        </a>
      <a href="responsibility-planner" routerLink="responsibility-planner" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="'shift_planner' | translate"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-calendar-week font-12"></i>
        @if (!shared.sidebarCollapsed) { <span>{{'shift_planner'|translate}}</span> }
      </a>
      <a href="files" routerLink="files" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="'modules.MANUALS' | translate"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-folder2-open font-12"></i>
        @if (!shared.sidebarCollapsed) { <span>{{'modules.MANUALS'|translate}}</span> }
      </a>
        <a href="archived-files" routerLink="archived-files" routerLinkActive="active"
          class="btn btn-sm d-flex gap-2 align-items-center"
          [title]="'archived_files' | translate"
          (click)="offcanvasService.dismiss()">
          <i class="bi bi-archive font-12"></i>
          @if (!shared.sidebarCollapsed) { <span>{{'archived_files'|translate}}</span> }
        </a>
    </ng-container>
    <a href="error-counters" routerLink="error-counters" routerLinkActive="active"
      class="btn btn-sm d-flex gap-2 align-items-center"
      [title]="(('alert_management' | translate) + (alertErrorCount > 0 ? ' (' + alertErrorCount + ')' : ''))"
      (click)="offcanvasService.dismiss()">
      <i class="bi bi-exclamation-triangle font-12 position-relative">
        @if (alertErrorCount > 0 && shared.sidebarCollapsed) {
          <span class="tk-menu-badge tk-menu-badge--err">{{ alertErrorCount }}</span>
        }
      </i>
      @if (!shared.sidebarCollapsed) {
        <span>{{'alert_management'|translate}}</span>
        @if (alertErrorCount > 0) {
          <span class="badge rounded-pill tk-menu-pill tk-menu-pill--err ms-auto">{{ alertErrorCount }}</span>
        }
      }
    </a>
    @if (loggedUser.hasModule('SpotPrices')) {
      <a href="spot-prices" routerLink="spot-prices" routerLinkActive="active"
        class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="'spot_prices.title' | translate"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-graph-up-arrow font-12"></i>
        @if (!shared.sidebarCollapsed) { <span>{{'spot_prices.title'|translate}}</span> }
      </a>
    }
    <a href="setting" routerLink="setting" routerLinkActive="active"
      class="btn btn-sm d-flex gap-2 align-items-center"
        [title]="'setting' | translate"
        (click)="offcanvasService.dismiss()">
        <i class="bi bi-gear font-12"></i>
        @if (!shared.sidebarCollapsed) { <span>{{'setting'|translate}}</span> }
      </a>
    <a href="logs" routerLink="logs" routerLinkActive="active"
      class="btn btn-sm d-flex gap-2 align-items-center"
      [title]="'logs' | translate"
      (click)="offcanvasService.dismiss()">
      <i class="bi bi-code-slash font-12"></i>
      @if (!shared.sidebarCollapsed) { <span>{{'logs'|translate}}</span> }
    </a>
    <button class="btn btn-sm d-flex gap-2 align-items-center"
      [title]="'logout' | translate"
      (click)="logout();offcanvasService.dismiss()">
      <i class="bi bi-box-arrow-right font-12"></i>
      @if (!shared.sidebarCollapsed) { <span>{{'logout'|translate}}</span> }
    </button>

    <button class="btn btn-sm d-flex gap-2 align-items-center"
      [title]="(theme.isDark ? 'theme.light' : 'theme.dark') | translate"
      (click)="theme.toggle()">
      <i class="bi font-12" [class.bi-moon-stars]="!theme.isDark" [class.bi-brightness-high]="theme.isDark"></i>
      @if (!shared.sidebarCollapsed) {
        <span>{{(theme.isDark ? 'theme.light' : 'theme.dark')|translate}}</span>
      }
    </button>

    <div ngbDropdown placement="top-start top-end top" display="dynamic" container="body" class="w-100">
      <button class="btn btn-sm w-100 d-flex gap-2 align-items-center"
        [title]="('lang_'+shared.transService.currentLang) | translate"
        ngbDropdownToggle>
        <i class="bi bi-flag font-12"></i>
        @if (!shared.sidebarCollapsed) {
          <span>{{('lang_'+shared.transService.currentLang)|translate}}</span>
        }
      </button>
      <div ngbDropdownMenu class="dropdown-flags">
        @for (lang of languages; track lang) {
          <a ngbDropdownItem (click)="changeLanguage(lang);">
            <img src="assets/flags/{{lang}}.png" alt="">
          </a>
        }
      </div>
    </div>

    @if (shared.login?.ntfy_topic) {
      <div class="ntfy-row" [title]="'my_ntfy_topic' | translate">
        <a class="ntfy-btn" [href]="shared.login.ntfy_url" [ngbTooltip]="shared.login.ntfy_url" container="body"
          [attr.aria-label]="('my_ntfy_topic' | translate) + ' — ' + ('ntfy_link_app' | translate)">
          <i class="bi bi-bell"></i>
        </a>
        <a class="ntfy-btn" [href]="shared.login.ntfy_web_url" target="_blank" rel="noopener"
          [ngbTooltip]="shared.login.ntfy_web_url" container="body"
          [attr.aria-label]="('my_ntfy_topic' | translate) + ' — ' + ('ntfy_link_web' | translate)">
          <i class="bi bi-box-arrow-up-right"></i>
        </a>
      </div>
    }
  <div class="version">v{{version}}</div>
</div>
</ng-template>
